import { useMutation } from '@tanstack/react-query';
import { POST, POST_OTP_VERIFY } from '../../../services';
import { openAlert } from '../../../components/alert/hooks';
import { navigateTo } from '../../../utils/navigation';
import { ROUTES_PATH } from '../../../resources/routes-name';

export const useVerifyOtp = ({ onSuccessCallBack }) => {
  const { mutate, isPending } = useMutation({
    mutationFn: async (payload) => {
      const response = await POST(POST_OTP_VERIFY(), payload);
      onSuccessCallBack && onSuccessCallBack(response);
      return response.result;
    },
    onSuccess: () => {
      openAlert({
        model: 'message',
        type: 'success',
        message: 'ลงทะเบียนเบอร์โทรศัพท์สำเร็จ',
      });
      setTimeout(() => {
        navigateTo({
          pathname: ROUTES_PATH.ROUTE_HOME.PATH,
        });
        window.location.reload();
      }, 1500);
    },
  });
  return { mutate, loading: isPending };
};
